<template>
    <div>
        <div id="diagramChart13" style="width: 850px; height: 600px;" v-loading="loading"></div>
    </div>
</template>

<script>
export default {
    inheritAttrs: false,
    props: ['data'],
    data() {
        return {
            loading: false,
            paramsData: null,
            diagramChart: null,
            option: {}
        }
    },
    created() {

    },
    methods: {
        async loadData() {
            this.loading = true;
            var url = "";
            if (this.paramsData.st === 1) {
                if (this.paramsData.analysis === 0) {
                    url = "search/menus/analysis/" + this.paramsData.analysisDbType + "/" + this.paramsData.type;
                } else {
                    url = "search/type/analysis/" + this.paramsData.type;
                }
            } else {
                url = "search/custom/analysis";
            }

            this.paramsData.params.analysisField = 'ipcGroup';
            this.paramsData.params.analysisSort = '';
            this.paramsData.params.analysisSize = 20;
            const { data: res } = await this.$http.post(url, this.paramsData.params);
            if (res.code == 0) {
                if (res.data == null) {
                    this.$message.error('没有数据');
                    return;
                }

                this.option.xAxis.data = res.data[0];
                this.option.series[0].data = res.data[1];
                this.diagramChart.setOption(this.option);
                console.log(res.data);
            } else {
                this.$message.error(res.msg);
            }

            this.loading = false;
        },
        drawChart() {
            if (this.diagramChart == null) {
                this.diagramChart = this.$echarts.init(
                    document.getElementById("diagramChart13")
                );
            }

            this.option = {
                grid: {
                    bottom: '20%',
                },
                title: {
                    text: 'IPC大组分布'
                },
                tooltip: {
                    trigger: "axis",
                },
                toolbox: {
                    show: true,
                    feature: {
                        saveAsImage: {},
                    },
                },
                xAxis: {
                    name: 'IPC大组',
                    type: 'category',
                    axisLabel: {
                        rotate: 45
                    },
                    data: []
                },
                yAxis: {
                    name: '件数',
                    type: 'value'
                },
                series: [
                    {
                        data: [],
                        type: 'bar'
                    }
                ]
            };

            this.diagramChart.clear();
            this.diagramChart.setOption(this.option);
        }
    },
    mounted() {
        this.paramsData = this.data;
        this.loadData();
        this.drawChart();
    }
}
</script>

<style>

</style>